import React from 'react';
import Facebook from '@material-ui/icons/Facebook';
import YouTube from '@material-ui/icons/YouTube';
import Instagram from '@material-ui/icons/Instagram';
import LinkedIn from '@material-ui/icons/LinkedIn';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import WebIcon from '@material-ui/icons/Web';
import { useTranslation } from 'react-i18next';
import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../redux/enums/ConfigResourceProps';

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.footerText,
    fontSize: '3rem',
  },
  xIcon: {
    width: '2.3rem',
    position: 'relative',
    top: '-7px',
    left: '-2px',
  },
}));
export default ({ iconName }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const frontendCustomisation = useConfiguration(ConfigResourceProps.FRONTEND_CUSTOMISATION);
  switch (iconName) {
    case 'facebook':
      return <Facebook className={classes.icon} />;
    case 'youtube':
      return <YouTube className={classes.icon} />;
    case 'instagram':
      return <Instagram className={classes.icon} />;
    case 'linkedin':
      return <LinkedIn className={classes.icon} />;
    case 'twitter':
      return <img src="/img/x_logo.svg" className={classes.xIcon} alt="x.com" />;
    case 'website':
      return <WebIcon className={classes.icon} />;
    case 'office':
      return (
        <img
          src={
            i18n.exists?.('footerLogo.translated')
              ? t('footerLogo.translated')
              : frontendCustomisation?.resource?.footerLogo
          }
          className={classes.icon}
          height={50}
          alt="EPO"
        />
      );
    default:
      return <Icon>{iconName}</Icon>;
  }
};
